module.exports = __webpack_public_path__ + "img/undraw_family_vg76.c1d3a653.svg";